<h2 mat-dialog-title>How do you want to get prompts?</h2>
<mat-dialog-content class="dialog-content">
  <p class="source-question">How would you like to get started?</p>
  <mat-radio-group class="source-options" [(ngModel)]="promptSource" (ngModelChange)="onSourceChange()">
    <label class="radio-option" [class.radio-option-selected]="promptSource === 'generate'">
      <mat-radio-button value="generate"></mat-radio-button>
      <span class="radio-label">Generate prompts by AI</span>
    </label>
    <label class="radio-option" [class.radio-option-selected]="promptSource === 'upload'">
      <mat-radio-button value="upload"></mat-radio-button>
      <span class="radio-label">Upload Your Prompts</span>
    </label>
    <label class="radio-option" [class.radio-option-selected]="promptSource === 'select'">
      <mat-radio-button value="select"></mat-radio-button>
      <span class="radio-label">Select from Prompt Creation</span>
    </label>
  </mat-radio-group>

  @if (promptSource === 'generate') {
    <div class="option-panel project-details">
      <h4>Project details</h4>
      <p><strong>Brand:</strong> {{ data.projectDetails?.brand || data.projectDetails?.projectName || '—' }}</p>
      <p><strong>Category:</strong> {{ data.projectDetails?.category || '—' }}</p>
      <p><strong>Industry:</strong> {{ data.projectDetails?.industry || '—' }}</p>
      <p><strong>Country:</strong> {{ data.projectDetails?.country || '—' }}</p>
      <p class="hint">Prompts will be generated by AI (15–20) from your project context.</p>
    </div>
  }

  @if (promptSource === 'upload') {
    <div class="option-panel upload-panel">
      <input type="file" #fileInput hidden accept=".txt,.csv" (change)="onFileSelected($event)" />
      <button mat-stroked-button (click)="fileInput.click()">Choose file (TXT or CSV)</button>
      @if (validatingUpload) {
        <span class="status">Validating…</span>
      }
      @if (uploadErrors.length > 0) {
        <ul class="errors">
          @for (e of uploadErrors; track e) {
            <li>{{ e }}</li>
          }
        </ul>
      }
      @if (uploadPrompts.length > 0) {
        <p class="preview">{{ uploadPrompts.length }} prompts loaded. Preview: {{ uploadPrompts.slice(0, 3).join('; ') }}{{ uploadPrompts.length > 3 ? '…' : '' }}</p>
      }
    </div>
  }

  @if (promptSource === 'select') {
    <div class="option-panel select-panel">
      @if (loadingResearchList) {
        <p>Loading Prompt Creation list…</p>
      } @else if (researchList.length === 0) {
        <p>No Prompt Creation researches found. Create some in the "Prompt Creation" tab first.</p>
      } @else {
        <p class="research-list-label">Choose a research</p>
        <mat-radio-group class="research-options" [(ngModel)]="selectedResearchId" (ngModelChange)="onResearchSelectionChange()">
          @for (r of researchList; track r.id) {
            <label class="radio-option research-option" [class.radio-option-selected]="selectedResearchId === r.id">
              <mat-radio-button [value]="r.id"></mat-radio-button>
              <span class="radio-label">{{ r.research_name }} ({{ r.prompt_count }} prompts)</span>
            </label>
          }
        </mat-radio-group>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="onCancel()">Cancel</button>
  <button type="button" mat-raised-button color="primary" (click)="onStart()" [disabled]="!canStart">
    Start analysis
  </button>
</mat-dialog-actions>
